module.exports = __webpack_public_path__ + "static/media/linkedin-payment-3-mobile-es.2413113c.png";